import React from 'react';

import { Grid, Link, Stack, Typography } from '@mui/material';

import { NFTSaleDetails, ScreenShots } from '..';
import { LoadingHOC, NFTHeader } from '../../common_components';
import { useFetchNftDetail } from '../../hooks/useClientDataService';
import { StyledNFTDetailsCard, useStyles } from '../styles';

export const NFTDetailsScreen = () => {
  const styles = useStyles();

  const { data: nftDetails, isLoading } = useFetchNftDetail(localStorage.getItem('nftTokenId'));

  if (isLoading) {
    return <LoadingHOC />;
  }

  return (
    <div className={styles.nftDetailsContainer}>
      <NFTHeader {...nftDetails} />
      <Stack className={styles.detailsContainer}>
        <NFTSaleDetails {...nftDetails} />
      </Stack>
      <Stack sx={{ mt: 5 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={2} />

          <Grid item xs={12} md={4}>
            <ScreenShots
              attachments={nftDetails?.attachments?.filter(
                (item) => item.attachment_type === 'ATTACHMENTS'
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {nftDetails?.description && (
              <StyledNFTDetailsCard width="70%">
                <Typography variant="h6" gutterBottom component="div">
                  {`Description`}
                </Typography>
                <Typography variant="body2" gutterBottom component="div">
                  {nftDetails?.description}
                </Typography>
              </StyledNFTDetailsCard>
            )}
            {nftDetails?.sale_details?.length > 0 && (
              <StyledNFTDetailsCard width="70%" sx={{ mt: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  {`How To participate`}
                </Typography>

                {nftDetails?.sale_details?.map((sale_item, index) => (
                  <Stack key={index} direction="row">
                    {sale_item.details_link ? (
                      <Link
                        href={sale_item.details_link}
                        underline="hover"
                        target="_blank"
                        rel="noopener"
                        key={index}>
                        {'Details'}
                      </Link>
                    ) : (
                      <Typography variant="body2" gutterBottom component="div">
                        {'Details'}
                      </Typography>
                    )}

                    <Typography
                      key={sale_item.sale_detais_tex}
                      variant="body2"
                      gutterBottom
                      component="div"
                      textAlign="center"
                      sx={{ mr: 2 }}>
                      {` : ${sale_item.sale_details_text}`}
                    </Typography>
                  </Stack>
                ))}
              </StyledNFTDetailsCard>
            )}
          </Grid>
        </Grid>
      </Stack>
    </div>
  );
};
export default NFTDetailsScreen;
